const LANGUAGES = {
  arabic: { abbreviation: 'ar', bcp47: 'ar-IQ' },
  bengali: { abbreviation: 'bn', bcp47: 'bn' },
  cantonese: { abbreviation: 'zh', bcp47: 'zh-HK' },
  chinese: { abbreviation: 'zh', bcp47: 'zh-CN' },
  creole: { abbreviation: 'ht', bcp47: 'ht' },
  english: { abbreviation: 'en', bcp47: 'en' },
  french: { abbreviation: 'fr', bcp47: 'fr' },
  german: { abbreviation: 'de', bcp47: 'de' },
  hawaiian: { abbreviation: 'haw', bcp47: 'haw' },
  hindi: { abbreviation: 'hi', bcp47: 'hi' },
  ilocano: { abbreviation: 'ilo', bcp47: 'ilo' },
  japanese: { abbreviation: 'ja', bcp47: 'ja' },
  khmer: { abbreviation: 'km', bcp47: 'km' },
  korean: { abbreviation: 'ko', bcp47: 'ko' },
  russian: { abbreviation: 'ru', bcp47: 'ru' },
  somali: { abbreviation: 'so', bcp47: 'so' },
  spanish: { abbreviation: 'es', bcp47: 'es' },
  tagalog: { abbreviation: 'tl', bcp47: 'tl' },
  thai: { abbreviation: 'th', bcp47: 'th' },
  ukrainian: { abbreviation: 'uk', bcp47: 'uk' },
  vietnamese: { abbreviation: 'vi', bcp47: 'vi' },
};

export const abbreviations = Object.fromEntries(
  Object.entries(LANGUAGES).map(([key, { abbreviation }]) => [
    key,
    abbreviation,
  ]),
);

export const LANGUAGE_TO_BCP47 = Object.fromEntries(
  Object.entries(LANGUAGES).map(([key, { bcp47 }]) => [key, bcp47]),
);
